module.exports = __webpack_public_path__ + "static/media/jenza_design.6c29d4e9.jpg";